function toStringOrNull(value) {
    return typeof value === "string" && value.trim().length > 0
        ? value.trim()
        : null;
}
function extractFileType(rawItem) {
    const metadata = rawItem.metadata || {};
    const candidates = [
        toStringOrNull(metadata.file_type),
        toStringOrNull(metadata.fileType),
        toStringOrNull(metadata.filename),
        toStringOrNull(metadata.file_name),
        toStringOrNull(rawItem.display_label),
        toStringOrNull(rawItem.label),
        toStringOrNull(rawItem.value),
    ];
    for (const candidate of candidates) {
        if (!candidate) {
            continue;
        }
        const lastDotIndex = candidate.lastIndexOf(".");
        if (lastDotIndex <= 0 || lastDotIndex === candidate.length - 1) {
            continue;
        }
        return candidate.slice(lastDotIndex + 1).toLowerCase();
    }
    return undefined;
}
function extractFileDisplayName(rawItem) {
    const metadata = rawItem.metadata || {};
    const candidates = [
        toStringOrNull(metadata.display_filename),
        toStringOrNull(metadata.original_filename),
        toStringOrNull(metadata.filename),
        toStringOrNull(metadata.file_name),
    ];
    for (const candidate of candidates) {
        if (!candidate) {
            continue;
        }
        return candidate;
    }
    return undefined;
}
export function mapMentionCategory(category) {
    switch (category) {
        case "cell_range":
            return "cellRange";
        case "chart":
            return "chart";
        case "sheet":
            return "sheet";
        case "file":
        default:
            return "file";
    }
}
export function normalizeBackendMentionItem(rawItem) {
    const category = mapMentionCategory(rawItem.category);
    const source = category === "file" ? "external" : "workbook";
    const fileType = category === "file" ? extractFileType(rawItem) : undefined;
    const fileDisplayName = category === "file" ? extractFileDisplayName(rawItem) : undefined;
    const fallbackLabel = rawItem.display_label || rawItem.label || rawItem.value;
    const resolvedLabel = fileDisplayName || rawItem.label || fallbackLabel;
    const resolvedDisplayLabel = fileDisplayName || fallbackLabel;
    return {
        id: String(rawItem.id || rawItem.value || rawItem.label),
        type: "file",
        category,
        label: resolvedLabel,
        displayLabel: resolvedDisplayLabel,
        value: rawItem.value || rawItem.label,
        source,
        fileType,
        metadata: rawItem.metadata || {},
    };
}
export function normalizeBackendMentionSection(section) {
    const items = (section.items || []).map(normalizeBackendMentionItem);
    return {
        id: section.id,
        title: section.title,
        category: mapMentionCategory(section.category),
        items,
        totalCount: section.total_count || items.length,
    };
}
export class MentionServiceBase {
    normalizeQuery(query) {
        return (query || "").trim();
    }
    filterItemsByLabel(items, query) {
        const normalized = this.normalizeQuery(query).toLowerCase();
        if (!normalized) {
            return items;
        }
        return items.filter((item) => item.label.toLowerCase().includes(normalized));
    }
    mergeSectionByCategory(sections, localSection, category) {
        if (!localSection) {
            return sections;
        }
        const existingIndex = sections.findIndex((section) => section.category === category);
        if (existingIndex === -1) {
            return [...sections, localSection];
        }
        const existing = sections[existingIndex];
        const deduped = new Map();
        [...existing.items, ...localSection.items].forEach((item) => {
            const key = `${item.value}`.toLowerCase();
            if (!deduped.has(key)) {
                deduped.set(key, item);
            }
        });
        const mergedItems = Array.from(deduped.values());
        const merged = {
            ...existing,
            items: mergedItems,
            totalCount: Math.max(existing.totalCount, localSection.totalCount, mergedItems.length),
        };
        const next = [...sections];
        next[existingIndex] = merged;
        return next;
    }
}
